import { useRef } from 'react';
import useValidateForm from './hooks/useValidateForm/useValidateForm';
import { useLoader } from '../../../providers/LoaderProvider';
import { usePushdownContext } from '../../../../../providers/Pushdown/PushdownProvider';
import usePrequalSubmitAPI from './hooks/useAcquisitionsSubmit/useAcquisitionSubmit';
import useHandleSubmitResponse from './hooks/useHandleSubmit/useHandleSubmitResponse';
import useHandleError from './hooks/useHandleSubmit/hooks/useHandleError';
import SessionStorage from '../../../../../utils/SessionStorage';
import { acquisitionApiRequest, AcquisitionInitResponse } from '../../../../../utils/acquisition-api/AcquisitionApi';

export default function useFormDirections() {
    const submitting = useRef<boolean>(false);
    const { closePushdown } = usePushdownContext();
    const { setShouldRenderLoader } = useLoader();
    const { validateForm, handleValidationError } = useValidateForm();
    const { acquistionsSubmit } = usePrequalSubmitAPI();
    const { submitResponseHandler } = useHandleSubmitResponse(submitting);
    const { handleSubmitError } = useHandleError();

    const onSubmitHandler = () => {
        if (!submitting.current) {
            submitting.current = true;

            const currentlyFocusedElement = document.activeElement as HTMLInputElement;
            currentlyFocusedElement.blur();

            validateForm()
                .then(() => {
                    closePushdown();
                })
                .then(() => {
                    setShouldRenderLoader(true);
                })
                .then(async () => {
                    if (!SessionStorage.verifyNotEmpty('initResponse')) {
                        const initResponse = await acquisitionApiRequest<AcquisitionInitResponse>('init-compare-api', {});
                        if (initResponse.data.PQMaintenanceMode) {
                            window.location.assign('/pre-qualification/data-entry/updating-systems');
                            return;
                        }
                        SessionStorage.set(
                            'initResponse',
                            JSON.stringify(initResponse.data),
                        );
                    }

                    const { data } = await acquistionsSubmit();

                    if (data) {
                        await submitResponseHandler(data);
                    } else {
                        setShouldRenderLoader(false);
                    }
                })
                .catch(error => {
                    const { message } = error;
                    if (message && message === 'validation error') {
                        handleValidationError(error.payload);
                        submitting.current = false;
                    } else if (message && message === 'loqate error') {
                        submitting.current = false;
                    }  else {
                        handleSubmitError(submitting)(error);
                    }
                });
        }
    };

    return {
        onSubmitHandler,
    };
}
